/* eslint-disable */
import { saveAs } from 'file-saver'
import * as XLSX from 'xlsx'

export function exportJsonToExcel(tHeader, jsonData, filename = 'excel-list', filters = []) {
    const data = jsonData.map(item => filters.map(key => item[key]))
    data.unshift(tHeader)

    const ws = XLSX.utils.aoa_to_sheet(data)
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

    // 生成Excel文件并下载
    const wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
    saveAs(new Blob([wbout], { type: 'application/octet-stream' }), `${filename}.xlsx`)
}